<template>
    <div class="container-fluid">

        <CRow class="pr-2">
    <CCol col="10" xl="10" class="p-0">
      <CCard class="pt-2">
        <CCardBody>
          <a-card class="edit-card" style="margin:0; margin-top:10px" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Právomoci</h6>
                            Všetky právomoci</span>
                          <span slot="extra">
                                            <a-button type="primary" @click="newPermission">Nová právomoc</a-button>
                                  </span>

                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :rowKey="record => record.id"
                                    :dataSource="data"
                                    :loading="loading"
                                    class="table-flush">
                                <template slot="name" slot-scope="permission">

                                            <sidebar-item :link="{name: 'Upraviť', path: '/permission/' + permission.id}"/>
                                            <a-popconfirm
                                                    title="Are you sure delete this permission?"
                                                    @confirm="confirm(permission.id)"
                                                    @cancel="cancel"
                                                    okText="Yes"
                                                    cancelText="No">
                                                 <a-button type="link" textColor="default" title="Zmazať"><span class="v-btn__content" data-no-activator=""><svg class="pc-icon" style="width: 20px; height: 20px;"><use xlink:href="/assets/svg/sprite.svg#custom-trash"></use></svg></span></a-button>
                                            </a-popconfirm>
                                        </template>

                            </a-table>
                        </div>
                        </a-card>
                        <a-modal title="Nová právomoc" centered  v-model="permissionModal"  @cancel="permissionModal = false" v-if="permissionModal" @ok="addPermission">

                          <a-form-item label="Názov právomoci">
                          <a-input v-model="permission.title" />
                          </a-form-item>
                          <a-form-item label="Slug právomoci">
                          <a-input v-model="permission.slug"/>
                          </a-form-item>
                        </a-modal>
                        </CCardBody>
                        </CCard>
                        </CCol>

   <CCol col="2" xl="2" class=" option-card pl-0">
<CCard class="pl-0 pt-0">
  <CCardBody>
    <a-card class="edit-card" style="margin:0; padding:15px;" :loading="saving">
     <div class="option-buttons">

            <router-link :to="'/users'"><a-button type="secondary" class="mr-2">Zoznam používateľov</a-button></router-link>
            <router-link :to="'/roles'"><a-button type="secondary" class="mr-2">Zoznam rolí</a-button></router-link>
                            </div>

      </a-card>

  </CCardBody>
</CCard>
  </CCol>
  </CRow>

    </div>
</template>
<script>
    import {dataService} from "../_services";
    import {Popconfirm} from "ant-design-vue"

    const columns = [
         {
            title: '',
            width: '10px',
        },
        {
            title: 'Právomoc',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'slug',
            dataIndex: 'slug',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        },
           {
            title: '',
            width: '10px',
        },
    ];

    export default {
        name: "permissions",
        components: {
            "a-popconfirm": Popconfirm
        },
        data() {
            return {
                data: [],
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
                permissionModal:false,
                permission:{title:'',slug:''},
                columns,
            };
        },
        mounted() {
            this.fetch();
        },
        methods: {
          addPermission()
          {
                dataService.axiosPost('permission', this.permission).then(()=> { this.fetch();
                  this.permission = {title:'',slug:''};
                });
          },
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
            newPermission()
            {
              this.permissionModal = true;

            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch(this.$options.name).then(results => {
                    this.data = results;
                    this.loading = false;
                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }

    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }

    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
